import React, { memo, useRef } from 'react';
import { Typography } from 'fronton-react';
import { HoverVideo, LinkWithGAPromoClick, Section, Swiper, SwiperSlide } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey, removeSpecialCharacters } from 'utils';
import {
  relatedProductsCard,
  relatedProductsCardImage,
  relatedProductsCardImageWrapper,
  relatedProductsTitle,
  relatedProductsSlide,
} from './related-products-styles';

type TProps = {
  elementBlock: string;
  title: string;
  cards: {
    image: string;
    videoSrc?: string;
    title: string;
    href: string;
  }[];
};

/**
 * Вью секции с сопутствующими товарами
 */
export const RelatedProducts: React.FC<TProps> = memo(({ cards, elementBlock, title }) => {
  const bannerRefs = useRef<HTMLImageElement[]>([]);

  const promotions = cards.map((card, index) => ({
    name: `${elementBlock}_сопутствующие_товары`,
    creative: removeSpecialCharacters(card.title),
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(bannerRefs, elementBlock, promotions);

  return (
    <Section>
      <Typography className={relatedProductsTitle} variant="h3" size="extra" as="h2">
        {title}
      </Typography>

      <Swiper slidesPerView="auto">
        {cards.map(({ title: cardTitle, image, href, videoSrc }, index) => (
          <SwiperSlide className={relatedProductsSlide} key={createElementKey('related-product', index)}>
            <LinkWithGAPromoClick
              className={relatedProductsCard}
              elementBlock={elementBlock}
              position={index}
              promotion={promotions[index]}
              href={href}
              title={cardTitle}
            >
              <div className={relatedProductsCardImageWrapper}>
                {videoSrc
                  ? (
                    <HoverVideo
                      className={relatedProductsCardImage}
                      poster={image}
                      videoSrc={videoSrc}
                    />
                  ) : (
                    <img
                      alt={`Изображение для карточки ${title}`}
                      className={relatedProductsCardImage}
                      data-position={index}
                      ref={(el: HTMLImageElement | null) => {
                        if (el && bannerRefs) bannerRefs.current[index] = el;
                      }}
                      src={image}
                    />
                  )}
              </div>
              <Typography variant="m" size="body_accent">{cardTitle}</Typography>
            </LinkWithGAPromoClick>
          </SwiperSlide>
        ))}
      </Swiper>
    </Section>
  );
});
